__turbopack_context__.v({
  "pageWrapper": "policy-module__r3fc9W__pageWrapper",
  "section": "policy-module__r3fc9W__section",
  "sectionList": "policy-module__r3fc9W__sectionList",
  "sectionText": "policy-module__r3fc9W__sectionText",
  "sectionTitle": "policy-module__r3fc9W__sectionTitle",
  "title": "policy-module__r3fc9W__title",
  "updated": "policy-module__r3fc9W__updated",
});
